import HeroBanner from './HeroBanner.vue'

export default HeroBanner
